import React, { useState, createContext } from "react";

export const BuahContext = createContext();

export const BuahProvider = props => {
  const [buah, setBuah] = useState([
    {nama: "Nanas", hargaTotal: 100000, beratTotal: 4000 },
    {nama: "Manggis", hargaTotal: 350000, beratTotal: 10000},
    {nama: "Nangka", hargaTotal: 90000, beratTotal: 2000},
    {nama: "Durian", hargaTotal: 400000, beratTotal: 5000},
    {nama: "Strawberry", hargaTotal: 120000, beratTotal: 6000}
  ]);
  const [name, setName] = useState("")
  const [harga, setHarga] = useState(0)
  const [berat, setBerat] = useState(0)
  const [showForm, setShowForm] = useState(false)
  const [statusForm, setStatusForm] = useState("create")
  const [currentIndex, setCurrentIndex] = useState(-1)

  return (
    <BuahContext.Provider value={[buah, setBuah, name, setName, harga, setHarga, berat, setBerat, showForm, setShowForm, statusForm, setStatusForm, currentIndex, setCurrentIndex]}>
      {props.children}
    </BuahContext.Provider>
  );
};